module.exports = __webpack_public_path__ + "static/img/s44.8f9b321f.png";